/**
 * Ordinal words for „Защо е шеста спирка“, in each language.
 *
 * Bulgarian ordinals agree with their noun, and „спирка“ is feminine, so these
 * are the feminine forms. Written out to twenty, which is longer than any path
 * in the first world. Past that the page says „спирка 21“ instead, through
 * `book.why.numbered`, rather than build a number speller for a case that does
 * not exist yet.
 */

import type { Locale } from '../../shared/locale.ts'

const ORDINALS: Record<Locale, readonly string[]> = {
  bg: [
    'първа',
    'втора',
    'трета',
    'четвърта',
    'пета',
    'шеста',
    'седма',
    'осма',
    'девета',
    'десета',
    'единадесета',
    'дванадесета',
    'тринадесета',
    'четиринадесета',
    'петнадесета',
    'шестнадесета',
    'седемнадесета',
    'осемнадесета',
    'деветнадесета',
    'двадесета',
  ],
  en: [
    'first',
    'second',
    'third',
    'fourth',
    'fifth',
    'sixth',
    'seventh',
    'eighth',
    'ninth',
    'tenth',
    'eleventh',
    'twelfth',
    'thirteenth',
    'fourteenth',
    'fifteenth',
    'sixteenth',
    'seventeenth',
    'eighteenth',
    'nineteenth',
    'twentieth',
  ],
}

/** The word for position `n` (from 1), or null past the end of the list. */
export function ordinal(locale: Locale, n: number): string | null {
  return ORDINALS[locale][n - 1] ?? null
}
